import React from 'react'
import { shape, func, string } from 'prop-types'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { getPageName } from 'services/utility'

export const AsdaCustomLink = ({
  link, linkName, dispatch, linkClass,
}) => (
  <li className="custom-link">
    {/AsdaDotCom/i.test(link.path) ? (
      <NavLink
        to={link.path.replace(/\/pages\/AsdaDotCom/gi, '')}
        activeClassName="selected"
        onClick={() => dispatch({ type: 'CLOSE_LEFT_NAV' })}
      >
        {linkName}
      </NavLink>
    ) : (
      <a
        className={linkClass || ''}
        href={link.path.replace(/cmpid-pagename/gi, getPageName())}
        id={linkName}
      >
        {linkName}
      </a>
    )}
  </li>
)

AsdaCustomLink.propTypes = {
  link: shape().isRequired,
  linkName: string.isRequired,
  dispatch: func,
  linkClass: string,
}

AsdaCustomLink.defaultProps = {
  dispatch: x => x,
  linkClass: '',
}

export default connect()(AsdaCustomLink)



// WEBPACK FOOTER //
// ./components/asda-custom-link/index.js